import { statusBadge } from "@/lib/constants";

export default function StatusPill({ status, testid }) {
  const b = statusBadge(status);
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide border rounded-sm ${b.cls}`}
    >
      {b.label}
    </span>
  );
}
